module.exports = __webpack_public_path__ + "img/26-further-steps-are-needed.0708fb43.jpg";